export default "__VITE_ASSET__ot7sZdjH__"